
import { call, put } from "redux-saga/effects";
import axios from "../../axiosConfig";
import { ADD_NEW_CAMPAIGNS_FAILED, ADD_NEW_CAMPAIGNS_SUCCESS, DELETE_TAG_CAMPAIGN_FAILED, DELETE_TAG_CAMPAIGN_SUCCESS, GET_CAMPAIGNS_LIST_FAILED, GET_CAMPAIGNS_LIST_SUCCESS, GET_EDIT_TAG_DATA_FAILED, GET_EDIT_TAG_DATA_SUCCESS, GET_TAG_GENERATOR_FAILED, GET_TAG_GENERATOR_SUCCESS, UPDATE_EDIT_TAG_DATA_FAILED, UPDATE_EDIT_TAG_DATA_SUCCESS } from "../Actions/TagGeneratorAction";
import { TOAST_SHOW } from "../Actions/ToastAction";

export function* GetCampaignsListSaga(action: any): unknown {
    if(action.filtering.dsp==='DSP'){
        action.filtering.dsp=''
    }
    if(action.filtering.type==='Type'){
        action.filtering.type=''
    }
    /*if(action.filtering.env==='Environment'){
        action.filtering.env=''
    }*/
    if(action.filtering.exchange==='Exchange'){
        action.filtering.exchange=''
    }

    if(action.filtering.addOns==='Add-Ons'){
        action.filtering.addOns=''
    }
    
    try {
        const response = yield call(axios.get, `getTagCampaigns?dsp=${action.filtering.dsp}&type=${action.filtering.type}&exchange=${action.filtering.exchange}&addOns=${action.filtering.addOns}`); //&env=${action.filtering.env}
        const { data, status } = response

        if (status === 200) {
            yield put({ type: GET_CAMPAIGNS_LIST_SUCCESS, payload: data });
        }

    } catch (e: any) {
        yield put({ type: GET_CAMPAIGNS_LIST_FAILED, payload: [] });
    }
}

export function* GetTagGeneratorSaga(action: any): unknown {
    try {
        const response = yield call(axios.get, `Tagger?camp=${action.campName}`);
        const { data, status } = response
        // console.log(data, response);

        if (status === 200) {
            yield put({ type: GET_TAG_GENERATOR_SUCCESS, payload: data });
        }

    } catch (e: any) {
        yield put({ type: GET_TAG_GENERATOR_FAILED, payload: '' });
    }
}

export function* AddNewCampaignSaga(action: any): unknown {
    try {
        const response = yield call(axios.post, 'setCampaign', action.newCampaign);
        const { data, status } = response

        if (status === 200) {
            yield put({ type: ADD_NEW_CAMPAIGNS_SUCCESS, payload: data });
            yield put({
                type: TOAST_SHOW,
                payload: { message: 'New Campaign added successfully', severity: 'Success', show: true },
            });
        }

    } catch (e: any) {
        // if (e.response.status === 500) {
            yield put({ type: ADD_NEW_CAMPAIGNS_FAILED, payload: [] });
            yield put({
                type: TOAST_SHOW,
                payload: { message: e.response.data.error ? e.response.data.error: 'Something went wrong!', severity: 'Danger', show: true },
            });
        // } else {
        //     yield put({ type: ADD_NEW_CAMPAIGNS_FAILED, payload: [] });
        //     yield put({
        //         type: TOAST_SHOW,
        //         payload: { message: 'Something went wrong!', severity: 'Danger', show: true },
        //     });
        // }
    }
}

export function* GetEditTagDataSaga(action: any): unknown {
    try {
        const response = yield call(axios.get, `getCampaignData?camp=${action.campName}`);
        const { data, status } = response

        if (status === 200) {
            yield put({ type: GET_EDIT_TAG_DATA_SUCCESS, payload: data });
        }

    } catch (e: any) {
        yield put({ type: GET_EDIT_TAG_DATA_FAILED, payload: [] });
    }
}

export function* UpdateEditTagDataSaga(action: any): unknown {
    try {
        const response = yield call(axios.post, `editCampaign?campId=${action.campId}`, action.editCampaign);
        const { 
            //data, 
            status 
        } = response
        // console.log(response);
        if (status === 200) {
            yield put({ type: UPDATE_EDIT_TAG_DATA_SUCCESS });
            yield put({
                type: TOAST_SHOW,
                payload: { message: 'Updated Campaign successfully', severity: 'Success', show: true },
            });
        }

    } catch (e: any) {
        yield put({ type: UPDATE_EDIT_TAG_DATA_FAILED });
        yield put({
            type: TOAST_SHOW,
            payload: { message: 'Something went wrong!', severity: 'Danger', show: true },
        });
    }
}

export function* DeleteTagSaga(action:any):unknown{
    try {
        const response = yield call(axios.get, `deleteCampaign?campId=${action.id}`);
        const {
            //data,
            status
        } = response
        if(status===200){
            yield put({
                type:DELETE_TAG_CAMPAIGN_SUCCESS
            })
            yield put({
                type:TOAST_SHOW,
                payload: { message: 'Deleted Campaign successfully', severity: 'Success', show: true }
            })
        }
        
    } catch (error) {
        yield put({type:DELETE_TAG_CAMPAIGN_FAILED})
        yield put({
            type: TOAST_SHOW,
            payload: { message: 'Something went wrong!', severity: 'Danger', show: true },
        });
    }
}